import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
const api = process.env.REACT_APP_API_ADDRESS;

export const customerApi = createApi({
    reducerPath: 'administratorApi',
    tagTypes: ['Administrator'],
    baseQuery: fetchBaseQuery({
        baseUrl: api,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem("token");
            if(token) headers.set("token", token);
            return headers;
        }
    }),
  endpoints: (builder) => ({
      getCustomers: builder.query({
        query: () => `/api/administrator/get`,
        providesTags: ["Administrator"]
      }),

      auth: builder.mutation({
        query: (data) => ({
          url: '/api/administrator/auth',
          method: 'POST',
          body: { email: data.email, password: data.password},
        }),
        invalidatesTags: ["Administrator"]
      }),

      addCustomer: builder.mutation({
        query: (data) => ({
          url: '/api/administrator/add',
          method: 'POST',
          body: { email: data.email, name: data.name, password: data.password, permissions: data.permissions, role: data.role},
        }),
        invalidatesTags: ["Administrator"]
      }),

      deleteCustomer: builder.mutation({
        query: (data) => ({
          url: '/api/administrator/delete',
          method: 'DELETE',
          body: {user_id: data},
        }),
        invalidatesTags: ["Administrator"]
      }),

      updateCustomer: builder.mutation({
        query: (data) => ({
          url: '/api/administrator/update',
          method: 'PUT',
          body: data,
        }),
        invalidatesTags: ["Administrator"]
      }),

      getPermissions: builder.query({
        query: () => `/api/administrator/permissions/get`,
        providesTags: ["Administrator"]
      }),

    }),
  })

export const {
  useAuthMutation,
  useGetCustomersQuery,
  useAddCustomerMutation,
  useDeleteCustomerMutation,
  useUpdateCustomerMutation,
  useGetPermissionsQuery
} = customerApi;